
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformer01On as ObiTransformer01OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transformer-01-on.js';
 
 
 

 
 export const ObiTransformer01On = createComponent({
   react: React,
   tagName: 'obi-transformer-01-on',
   elementClass: ObiTransformer01OnElement,
   events: {
     
   }
  });
 
 